import { render } from "./ConfirmationInfo.vue?vue&type=template&id=0bf103ea&scoped=true&lang=pug"
import script from "./ConfirmationInfo.vue?vue&type=script&lang=js"
export * from "./ConfirmationInfo.vue?vue&type=script&lang=js"

import "./ConfirmationInfo.vue?vue&type=style&index=0&id=0bf103ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf103ea"]])

export default __exports__